import React, { Fragment, useState } from 'react'

import { Skeleton, TextField } from '@mui/material'

const SettingRoleDetail = ({ Data, isLoading = false, ...props }) => {
    const [data, setData] = useState({
        Id: '',
        Nama: '',
        Deskripsi: '',
    });
    const TextFieldStyle = { width: '95%', margin: '1%', backgroundColor: '#E0E0E0' }
    const TextFieldStyleChange = { width: '95%', margin: '1%' }
    const handleFieldChange = (fieldName, value) => {
        setData({
            ...data,
            [fieldName]: value,
        });
    };
    return (
        <Fragment>
            {isLoading ?
                <Fragment>
                    <Skeleton
                        height={'10vh'}
                    />
                    <Skeleton
                        height={'10vh'}
                    />
                    <Skeleton
                        height={'10vh'}
                    />
                </Fragment> :
                <Fragment>
                    <h3>
                        Role Detail
                    </h3>
                    <center>
                        <TextField
                            label='Id'
                            value={Data?.Id ? Data.Id : ''}
                            disabled
                            style={TextFieldStyle}
                        />
                        <TextField
                            label='Nama'
                            value={Data?.Nama ? Data.Nama : ''}
                            style={TextFieldStyleChange}
                            onChange={(e) => handleFieldChange('Nama', e.target.value)}
                        />
                        <TextField
                            label='Deskripsi'
                            value={Data?.Deskripsi ? Data.Deskripsi : ''}
                            style={TextFieldStyleChange}
                            onChange={(e) => handleFieldChange('Deskripsi', e.target.value)}
                        />
                    </center>
                </Fragment>}
        </Fragment>
    )
}

export default SettingRoleDetail